// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Component } from 'react';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'recu... Remove this comment to see the full error message
import t from 'recup';
import _ from 'underscore';

import { PowerUpItemType } from 'app/src/components/PowerUp';
import { LoadingSkeleton } from 'app/src/components/PowerUp/LoadingSkeleton';
import { BaseDirectoryView } from './BaseDirectoryView';

class DirectoryLoading extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Spinner';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.prototype.render = t.renderable(function (this: any) {
      return t.div('.directory-content-body', () => {
        return t.div('.directory-listing', () => {
          return _.times(this.props.numOfAtoms, () => {
            return t.div('.directory-listing-powerup', () => {
              return t.tag(LoadingSkeleton, {
                type: this.props.atomType,
              });
            });
          });
        });
      });
    });
  }
}

DirectoryLoading.initClass();

class DirectorySpinner extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Spinner';

    this.prototype.render = t.renderable(() =>
      t.div('.directory-listing', () =>
        t.div('.directory-spinner', () => t.div('.spinner.loading.centered')),
      ),
    );
  }
}

DirectorySpinner.initClass();

class DirectorySpinnerView extends BaseDirectoryView {
  eventSource() {
    return 'boardDirectorySpinnerScreen';
  }

  renderContent() {
    const { section, idPlugin, isEnabling } = this.options;

    if (_.contains(['category', 'custom', 'enabled'], section)) {
      return (
        <DirectoryLoading
          // @ts-expect-error TS(2769): No overload matches this call.
          numOfAtoms={24}
          atomType={PowerUpItemType.Description}
        />
      );
    } else if (idPlugin || isEnabling) {
      return <DirectorySpinner />;
    } else {
      return (
        // @ts-expect-error TS(2769): No overload matches this call.
        <DirectoryLoading numOfAtoms={6} atomType={PowerUpItemType.Featured} />
      );
    }
  }
}

export { DirectorySpinnerView };
